module.exports = __webpack_public_path__ + "static/Radoslav-Stankov-ad60bd440ab4555d8e8dfaf48f01796d.png";